var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputLabel = void 0;
var InputLabel_1 = __importDefault(require("./InputLabel"));
exports.InputLabel = InputLabel_1.default;
exports.default = InputLabel_1.default;
//# sourceMappingURL=index.js.map